export default {
      id: "truck_wash-usage",
      viewBox: "0 0 26 27",
      url: __webpack_public_path__ + "img/icons.svg#truck_wash",
      toString: function () {
        return this.url;
      }
    }